/**
 * 页面路由数据
 */
 import asyncComponent from "./asyncComponent.js";
 import SubRouter from "./subRouter";
 
 const Page = asyncComponent(() => import('pages/usercenter_home/Home.jsx'))
 const CePage = asyncComponent(() => import('entry/main/MainCon.jsx'))
 const UserCenterHome = asyncComponent(() => import('pages/usercenter_home/Home.jsx'))
 const MyApp = asyncComponent(() => import('pages/mgmt_myapp/MyApp.jsx'))
 const EntInfoH = asyncComponent(() => import('pages/login_history/History.jsx'))
 const UserBasicInfo = asyncComponent(() => import('pages/mgmt_user/UserBasicInfo.jsx'))
 const SecurityScoreInit = asyncComponent(() => import('pages/mgmt_security/SecurityScoreInit.jsx'))
 const MobileSecurityPWD = asyncComponent(() => import('pages/mgmt_security/SecurityPWD.jsx'))
 const SecurityMobile = asyncComponent(() => import('pages/mgmt_security/SecurityMobile.jsx'))
 const SecurityEmail = asyncComponent(() => import('pages/mgmt_security/SecurityEmail.jsx'))
 const UserAuthEntry = asyncComponent(() => import('pages/user_auth/index.jsx'))
 const AccLogout = asyncComponent(() => import('pages/logout/AccLogout.jsx'))
 const UserAccount = asyncComponent(() => import('pages/mgmt_user/UserAccount.jsx'))
 const EntInfo = asyncComponent(() => import('pages/enterprise_invite/EntInfo.jsx'))
 const Merge = asyncComponent(() => import('pages/mgmt_merge/merge.jsx'))
 const SsoShare = asyncComponent(() => import('pages/sso/ssoshare/index.jsx'))
 const SsoMfa = asyncComponent(() => import('pages/sso/ssomfa/index.jsx'))
 
 export const useData = [
     {
 
         path: '/usercenter',
         component: CePage,
         routes: [
             /** 用户信息 */
             {
                 exact: true,
                 id: 'user',
                 path: '/usercenter/user',
                 component: UserBasicInfo,
             },
 
             /** 安全评级 */
             {
 
                 exact: true,
                 id: 'securityscore',
                 path: '/usercenter/securityscore',
                 component: SecurityScoreInit
             },
             /** 修改密码 */
             {
 
                 exact: true,
                 id: 'security',
                 path: '/usercenter/security',
                 component: MobileSecurityPWD
 
             },
             /** 修改手机号 */
             {
 
                 exact: true,
                 id: 'mobileMOD',
                 path: '/usercenter/mobileMOD',
                 component: SecurityMobile,
 
             },
             /** 修改邮箱 */
             {
 
                 exact: true,
                 id: 'emailMOD',
                 path: '/usercenter/emailMOD',
                 component: SecurityEmail,
 
             },
             /***个人认证 */
             {
 
                 exact: true,
                 id: 'userauth',
                 path: '/usercenter/userauth',
                 component: UserAuthEntry,
 
 
             },
             /***帐号注销 */
             {
 
                 exact: true,
                 id: 'logout',
                 path: '/usercenter/logout',
                 component: AccLogout,
 
             },
             /*** 账号信息 */
             {
 
                 exact: true,
                 id: 'usermng',
                 path: '/usercenter/usermng',
                 component: UserAccount,
 
             },
 
             /** 左侧菜单用户合并 */
             {
 
                 exact: true,
                 id: 'merge',
                 path: '/usercenter/merge',
                 component: Merge,
 
             },
             /** 我的应用 */
             {
 
                 exact: true,
                 id: 'myapp',
                 path: '/usercenter/myapp',
                 component: MyApp,
             },
             /** 登录历史 */
             {
 
                 exact: true,
                 id: 'loginhistory',
                 path: '/usercenter/loginhistory',
                 component: EntInfoH,
             },
             /** 企业信息 */
             {
 
                 exact: true,
                 id: 'enterprise',
                 path: '/usercenter/enterprise',
                 component: EntInfo,
 
 
             },
             //sso分享
             {
 
                exact: true,
                id: 'ssoshare',
                path: '/usercenter/ssoshare',
                component: SsoShare,
            },{
 
                exact: true,
                id: 'ssomfa',
                path: '/usercenter/ssomfa',
                component: SsoMfa,
            },
             {
                 path: '/',
                 component: UserCenterHome,
                 // exact: true,
             },
         ]
     },
 
 ]
 